import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface AdminProduct {
    id: number;
    name: string;
    category: string;
    image: string;
    description: string;
    sort: number;
    status: boolean;
}

export interface AdminCertificate {
    id: number;
    title: string;
    category: string;
    description: string;
    fileName: string;
    filePath: string;
    year: string;
    sort: number;
    status: boolean;
}

export interface ContactRequestAdmin {
    id: number;
    fullName: string;
    company: string;
    email: string;
    phone: string;
    serviceCategory: string;
    priority: string;
    message: string;
    status: string;
    createdDate: string;
}


export interface AdminHomeData {
    hero: any;
    metrics: any[];
    trustItems: any[];
    industries: any[];
    badges: any[];
    cases: any[];
    process: any[];
    features: any[];
}

export interface AdminAboutData {
    hero: any;
    profile: any;
    features: any[];
    timeline: any[];
}

export interface AdminServiceItem {
    id: number;
    title: string;
    description: string;
    iconKey: string;
    ctaText: string;
    ctaUrl: string;
    sort: number;
    status: boolean;
}
export interface AdminSocialLink {
    id: number;
    name: string;
    iconKey: string;
    url: string;
    sort: number;
    status: boolean;
}
@Injectable({
    providedIn: 'root'
})
export class AdminApiService {

    private apiUrl = '/api/admin';

    constructor(private http: HttpClient) { }

    login(username: string, password: string): Observable<any> {
        return this.http.post(this.apiUrl + '/login', {
            username: username,
            password: password
        });
    }

    getProducts(): Observable<AdminProduct[]> {
        return this.http.get<AdminProduct[]>(this.apiUrl + '/products');
    }

    saveProduct(formData: FormData): Observable<any> {
        return this.http.post(this.apiUrl + '/products/save', formData);
    }

    deleteProduct(id: number): Observable<any> {
        return this.http.delete(this.apiUrl + '/products/' + id);
    }

    getCertificates(): Observable<AdminCertificate[]> {
        return this.http.get<AdminCertificate[]>(this.apiUrl + '/certificates');
    }

    saveCertificate(formData: FormData): Observable<any> {
        return this.http.post(this.apiUrl + '/certificates/save', formData);
    }

    deleteCertificate(id: number): Observable<any> {
        return this.http.delete(this.apiUrl + '/certificates/' + id);
    }

    getContactRequests(): Observable<ContactRequestAdmin[]> {
        return this.http.get<ContactRequestAdmin[]>(this.apiUrl + '/contact-requests');
    }

    updateContactRequestStatus(id: number, status: string): Observable<any> {
        return this.http.post(this.apiUrl + '/contact-requests/' + id + '/status', {
            status: status
        });
    }


    getAdminHome(): Observable<AdminHomeData> {
        return this.http.get<AdminHomeData>(this.apiUrl + '/home');
    }

    saveHomeHero(data: any): Observable<any> {
        return this.http.post(this.apiUrl + '/home/hero/save', data);
    }

    saveHomeItem(data: any): Observable<any> {
        return this.http.post(this.apiUrl + '/home/item/save', data);
    }

    deleteHomeItem(type: string, id: number): Observable<any> {
        return this.http.delete(this.apiUrl + '/home/item/' + type + '/' + id);
    }

    getAdminAbout(): Observable<AdminAboutData> {
        return this.http.get<AdminAboutData>(this.apiUrl + '/about');
    }

    saveAboutHero(data: any): Observable<any> {
        return this.http.post(this.apiUrl + '/about/hero/save', data);
    }

    saveAboutProfile(data: any): Observable<any> {
        return this.http.post(this.apiUrl + '/about/profile/save', data);
    }

    saveAboutItem(data: any): Observable<any> {
        return this.http.post(this.apiUrl + '/about/item/save', data);
    }

    deleteAboutItem(type: string, id: number): Observable<any> {
        return this.http.delete(this.apiUrl + '/about/item/' + type + '/' + id);
    }

    getAdminServices(): Observable<AdminServiceItem[]> {
        return this.http.get<AdminServiceItem[]>(this.apiUrl + '/services');
    }

    saveAdminService(data: AdminServiceItem): Observable<any> {
        return this.http.post(this.apiUrl + '/services/save', data);
    }

    deleteAdminService(id: number): Observable<any> {
        return this.http.delete(this.apiUrl + '/services/' + id);
    }
    getAdminSocialLinks(): Observable<AdminSocialLink[]> {
        return this.http.get<AdminSocialLink[]>(this.apiUrl + '/social-links');
    }

    saveAdminSocialLink(data: AdminSocialLink): Observable<any> {
        return this.http.post(this.apiUrl + '/social-links/save', data);
    }

    deleteAdminSocialLink(id: number): Observable<any> {
        return this.http.delete(this.apiUrl + '/social-links/' + id);
    }
    getFileUrl(path: string): string {
        if (!path) {
            return '#';
        }

        if (path.indexOf('http') === 0) {
            return path;
        }

        return this.apiUrl.replace('/api/admin', '') + path;
    }

    logout(): Observable<any> {
        return this.http.post(this.apiUrl + '/logout', {});
    }
}